import { observer } from "mobx-react";
import { useEffect } from "react";
import { RemoveCompanyBoardFromArticlesOfAssociationForm } from "./removeCompanyBoardFromArticlesOfAssociationDomain";
import {
  ArticleSelectorQuestion,
  LocalizedMarkdownQuestion,
  YesNoQuestion,
} from "@/dbot/common/commonComponents";
import { VBox } from "@/components-v2/Box";

import { useTranslation } from "@/stores/RootStoreContext";

export const RemoveCompanyBoardFromArticlesOfAssociationView = observer(
  function RemoveSignatureFromArticlesOfAssociationViewView({
    form,
  }: {
    form: RemoveCompanyBoardFromArticlesOfAssociationForm;
  }) {
    const { t } = useTranslation();

    useEffect(() => {
      form.init();
    }, [form]);

    return (
      <VBox gap={"md"}>
        <ArticleSelectorQuestion
          question={t("decisions.removecompanyBoard.paragraph")}
          model={form.paragraphNumber}
          onChange={form.setParagraphNumber}
          isLocked={form.isProjectLocked}
        />
        <YesNoQuestion
          question={t("decisions.companyBoard.remove-paragraph.paragraph-is-mix", {
            paragraph: form.paragraphNumber.selected,
          })}
          field={form.paragraphContainsMultipleClauses}
          onChange={form.toggleParagraphContainsMultipleClauses}
          isLocked={form.isProjectLocked}
        />
        {form.paragraphContainsMultipleClauses.value && (
          <LocalizedMarkdownQuestion
            name={"paragraph-texts"}
            question={t(
              "decisions.removeCompanyBoardFromAoA.changeArticlesOfAssociationBoardElectionParagraphText",
              {
                paragraph: form.paragraphNumber.selected,
              },
            )}
            textModels={form.paragraphTexts}
            isLocked={form.isProjectLocked}
          />
        )}
      </VBox>
    );
  },
);
